import disclosureQuotes from "./categories/disclosure-quotes";

const testimonials = disclosureQuotes;

export default testimonials;
